import { render } from "./IncDec.vue?vue&type=template&id=01e27452"
import script from "./IncDec.vue?vue&type=script&lang=js"
export * from "./IncDec.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__